import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../../context/app/appContext';
import axios from 'axios';
// import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import * as d3 from "d3";
import { Icon } from 'semantic-ui-react'

export const EnpsComponent = ({setEnps}) => {
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');

    const [currScore, setCurrScore] = useState(null)
    const [oldScore, setOldScore] = useState(null)
    const [scoreCategory, setScoreCategory] = useState('')

    const getEnpsScore = (poll) => {
        const responseDict = {detractors: 0, passives: 0, promotors: 0}
        var total = 0
        // const scoresList = poll.users.map(user => {return user.userOldChoiceIndex})
        poll.choices.forEach(choice => {
            if(parseInt(choice.description) >= 0 && parseInt(choice.description) <= 6){
                responseDict['detractors'] += choice.totalVotes
            }
            if(parseInt(choice.description) >= 7 && parseInt(choice.description) <= 8){
                responseDict['passives'] += choice.totalVotes
            }
            if(parseInt(choice.description) >= 9 && parseInt(choice.description) <= 10){
                responseDict['promotors'] += choice.totalVotes
            }
            total += choice.totalVotes;
        });
        setEnps({ ...responseDict, total: total})
        return ((responseDict['promotors'] / total) - (responseDict['detractors'] / total)) * 100
    };

    // const gradient = (score) => {
    //     const min = -100, max = 100;
    //     const middle = (min + max) / 2;
    //     const scale = 255 / (middle - min)

    //     if(score <= min) return "#FF0000"
    //     else if(score >= max) return "#00FF00"
    //     else if(score < middle){
    //         var hex = (parseInt((score-min)*scale)).toString(16)
    //         if(hex.length === 1){
    //             hex = "0"+hex
    //         }
    //         return `#FF${hex}00`
    //     }
    //     else{
    //         var hex = (255-parseInt((score-middle)*scale)).toString(16)
    //         if(hex.length === 1){
    //             hex = "0"+hex
    //         }
    //         return `#${hex}FF00`
    //     }
    // }

    useEffect(() => {
        (async function fetchPolls(){
            const response = await axios.post(baseURL + '/poll/fetch/hr', {}, {
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            });
            if(response.status === 200 && response.data){
                const enpsPolls = response.data.filter(poll => {return poll.pollType.toLowerCase() === 'enps'})
                const lastPoll = enpsPolls[enpsPolls.length - 2]
                const currentPoll = enpsPolls[enpsPolls.length - 1]
                // setCurrScore(getEnpsScore(currentPoll))
                // setOldScore(getEnpsScore(lastPoll))
                // setColor(gradient(99))
                setEnps({
                    detractors: 20,
                    passives: 10,
                    promotors: 70,
                    total: 100
                })
                const curr = 90
                const old = -20
                setOldScore(old)
                setCurrScore(curr)
                setScoreCategory(curr >= 50 ? 'Excellent' : curr >= 20 && curr < 50 ? 'Very Good' : curr > 0 && curr < 20 ? 'Good' : curr === 0 ? 'Neutral' : curr >= -10 && curr < 0 ? 'Not Good' : 'Bad' )
            }
            console.log(response)
        })();
    }, [])
    
    return (
        <div style={{paddingTop: 10, marginLeft: 10, marginRight: 10, display: 'flex', flexDirection: 'column', position: 'relative'}}>
            {currScore !== null && oldScore !== null && 
                <div style={{position: 'absolute', justifyContent: 'center', width: '100%', height: '100%', display: 'flex'}}>
                    <Icon name={currScore > oldScore ? "arrow up" : "arrow down"} size="small" color="black" style={{marginTop: 110}} />
                    <span style={{marginTop: 106, fontSize: 12, color: currScore > oldScore ? '#00CF8F' : '#FF5A5F', fontStyle: 'SFProText-Bold'}}>{Math.abs(currScore - oldScore)} pt</span>
                </div>
            }
            {/* {currScore !== null && oldScore !== null && 
                <div style={{position: 'absolute', justifyContent: 'center', width: '100%', height: '100%', display: 'flex'}}>
                    <span style={{marginTop: 116, fontSize: 14, color: 'rgba(133, 133, 133, 1)', fontStyle: 'SFProText-Bold'}}>{scoreCategory}</span>
                </div>
            } */}
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <div style={{color: 'rgba(133, 133, 133, 1)', fontSize: 16, fontStyle: 'SFProText-Bold'}}>eNPS Score</div>
                <div style={{color: d3.interpolateRdYlGn((currScore+100)/200), fontSize: 16, fontStyle: 'SFProText-Bold'}}>Excellent</div>
            </div>
            {/* <div style={{color: 'rgba(133, 133, 133, 1)', fontSize: 16, fontStyle: 'SFProText-Bold'}}>eNPS Score</div> */}
            {/* <svg style={{ height: 0, width: 0 }}>
                <defs>
                    <linearGradient
                    id='enps'
                    // gradientTransform='rotate(90)'
                    >
                    <stop offset="70%" stopColor={d3.interpolateRdYlGn((currScore+100)/200)} />
                    <stop offset="100%" stopColor='rgba(0,0,0,0.6)' />
                    </linearGradient>
                </defs>
            </svg> */}
            {currScore !== null && 
                <div style={{paddingTop: 5, width: '100%', display: 'flex', justifyContent: 'center'}}>
                    <CircularProgressbar
                        value={(currScore+100)/2}
                        text={`${currScore}`}
                        circleRatio={0.70}
                        strokeWidth={8}
                        styles={{
                            root: {height: 120, width: 120, },
                            path: {transform: 'rotate(0.65turn)', transformOrigin: 'center center', stroke: d3.interpolateRdYlGn((currScore+100)/200)},
                            // path: {transform: 'rotate(0.625turn)', transformOrigin: 'center center', stroke: `url(#enps)`},
                            trail: {transform: 'rotate(0.65turn)', transformOrigin: 'center center', strokeLinecap: 'round',},
                            text: {fill: d3.interpolateRdYlGn((currScore+100)/200), fontSize: 20, fontStyle: 'SFProText-Bold',
                                // backgroundImage: "-webkit-linear-gradient(rgba(0, 200, 136, 1), rgba(0, 0, 0, 1))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent"
                            }
                        }}
                    />
                </div>
            }
            
        </div>
    )
}